import React from "react";
import { useLocation } from "react-router-dom";
import CompanyPage from "../../components/companypage/CompanyPage";

const Eurasia = ({ galary }) => {
  const location = useLocation();
  // console.log(location);
  return (
    <>
      {galary ? (
        <div id="eurasia">
          <CompanyPage pathname={location.pathname}></CompanyPage>
        </div>
      ) : (
        <div>This is eurasia galary</div>
      )}
    </>
  );
};

export default Eurasia;
